export const GET_ALL_SOFTWARE = 'GET_ALL_SOFTWARE';


